import { SIGN_NAMES, type ZodiacSign } from '@/api/consts'
import type { UserLocation } from '@/api/schema'
import type { CalendarMoonPhaseId } from '@/api/schema/calendar'
import { Col } from '@/app/components/Flex/Flex'
import { Link } from '@/app/components/Link/Link'
import { MoonIcon } from '@/app/components/MoonIcon/MoonIcon'
import { Sign } from '@/app/components/Sign/Sign'
import PinSvg from '@/app/icons/pin.svg?react'
import { getMoonEventLink } from '@/app/utils/moon'
import { getMoonPhaseUrlSlug } from '@/shared/calendar/moon-phase'
import classNames from 'classnames'
import type { FunctionalComponent } from 'preact'
import styles from './index.module.scss'

export const MoonState: FunctionalComponent<{
  short?: boolean
  dates?: string
  at?: string
  phaseId?: CalendarMoonPhaseId
  phaseName?: string
  lunarDay?: number
  sing?: ZodiacSign
  location?: UserLocation
}> = props => {
  const hasPhase = Boolean(props.phaseId && props.phaseName)

  return (
    <Col
      gap={12}
      alignItems='center'
      class={styles.root}
    >
      {props.dates && <span>{props.dates}</span>}

      {props.sing && (
        <Col alignItems='center' gap={3}>
          <div class={styles.sign}>
            <Sign sign={props.sing} />
          </div>
          <Link
            class='color-link'
            to={getMoonEventLink(`~/moon/sign/${props.sing.toLowerCase()}`, props.at)}
          >
            {SIGN_NAMES[props.sing]}
          </Link>
        </Col>
      )}

      {props.lunarDay && (
        <Link
          class='color-link'
          to={getMoonEventLink(`~/moon/day/${props.lunarDay}`, props.at)}
        >
          {props.lunarDay}-й{' '}
          <span
            class={props.short ? styles.hideMobile : undefined}
          >
            лунный
          </span>{' '}
          день
        </Link>
      )}

      {hasPhase && (
        <Col alignItems='center' gap={3}>
          <MoonIcon phase={props.phaseId!} />
          <Link to={getMoonEventLink(`~/moon/phase/${getMoonPhaseUrlSlug(props.phaseId!)}`, props.at)} class='color-link'>
            {props.phaseName}
          </Link>
        </Col>
      )}

      {props.location && (
        <Link
          class={classNames('color-link', styles.link)}
          to={`~/moon/location?locationId=${props.location.id}`}
        >
          <Col alignItems='center' gap={3} as='span'>
            <PinSvg />
            <span class={styles.label}>
              {props.location?.name_ru || props.location?.name_en}
            </span>
          </Col>
        </Link>
      )}
    </Col>
  )
}
